import { render } from "./PrivacyPolicySchemajson.vue?vue&type=template&id=5da1096e"
import script from "./PrivacyPolicySchemajson.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicySchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__